import { TriggerEventAction } from './triggerEventActions';
import { TriggerEventContext } from './triggerEventContext';

export function triggerEventContextReducer(
    state: TriggerEventContext,
    { event, type }: TriggerEventAction
): TriggerEventContext {
    switch (type) {
        case 'eventTriggered':
            return {
                ...state,
                events: [...state.events, event],
            };
        default:
            if (type) {
                throw new Error(
                    `Unknown triggerEventContextReducer type ${type}`
                );
            }

            throw new Error('Missing triggerEventContextReducer type');
    }
}
